import { Box, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { format } from "date-fns";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Center } from "../../../../components/center";
import { ErrorPanel } from "../../../../components/error_panel";
import { Loading } from "../../../../components/loading";
import { IAsyncData } from "../../../../core/models";
import { isError, isPending, isSuccess } from "../../../../core/redux";
import { Routing } from "../../../../core/routing";
import { fixAmount } from "../../../../core/utils";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { ITransaction } from "../../../transaction/data/entities";
import { ETransactionType, transactionTypeToString } from "../../../transaction/data/models";
import { IClientHistory } from "../../data/entities";
import { singleClientHistoryFilterToQueryParams } from "../../data/filter";
import { clientHistoryReduxActions } from "../state/state";

function isPlusTransactionForClient(transaction: ITransaction): boolean | undefined {
  switch (transaction.type) {
    case ETransactionType.PRODUCT_BUY:
    case ETransactionType.EXPENSE:
    case ETransactionType.RECIEVE:
      return true;
    case ETransactionType.GIVE:
    case ETransactionType.PRODUCT_SELL:
      return false;
  }
}

interface IProps {
  clientId: string;
}

export const SingleClientHistoryList: React.FC<IProps> = ({ clientId }: IProps) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const search = history.location.search || `?${singleClientHistoryFilterToQueryParams({ clientId })}`;

  useEffect(() => {
    dispatch(clientHistoryReduxActions.getList(search));
  }, [dispatch, search]);
  const clientHistoryListBranch = useSelector<IAppReduxState, IAsyncData<IClientHistory[]>>(
    (state) => state.clientHistory.list,
  );

  return (
    <Box mt={3}>
      <Loading loading={isPending(clientHistoryListBranch)}>
        <Paper>
          <Table size="medium" className="list-table">
            <TableHead>
              <TableRow>
                <TableCell>Balans evvel</TableCell>
                <TableCell>Əməliyyat</TableCell>
                <TableCell>Əməliyyat novu</TableCell>
                <TableCell>Balans sonra</TableCell>
                <TableCell>Mal</TableCell>
                <TableCell>Temiz ceki</TableCell>
                <TableCell>Orta qiymet</TableCell>
                <TableCell>Toplam Qiymet</TableCell>
                <TableCell>Tarix</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {clientHistoryListBranch.data?.map((clientHistory) => {
                const plus = isPlusTransactionForClient(clientHistory.transaction);

                return (
                  <TableRow
                    hover
                    key={clientHistory.id}
                    onClick={() => {
                      history.push(Routing.generateDetailRoute(ROUTES.transaction, clientHistory.transaction.id));
                    }}
                  >
                    <TableCell>{fixAmount(clientHistory.balanceBefore)} AZN</TableCell>
                    <TableCell
                      style={{
                        color: plus ? "green" : "red",
                      }}
                    >
                      {plus ? "+" : "-"}
                      {clientHistory.transaction.amount} AZN
                    </TableCell>
                    <TableCell>{transactionTypeToString(clientHistory.transaction.type)}</TableCell>
                    <TableCell>{fixAmount(clientHistory.balanceAfter)} AZN</TableCell>
                    <TableCell>{clientHistory.transaction.product?.name}</TableCell>
                    <TableCell>
                      {clientHistory.transaction.cleanWeight && (
                        <span>{fixAmount(clientHistory.transaction.cleanWeight)} kq</span>
                      )}
                    </TableCell>
                    <TableCell>
                      {clientHistory.transaction.pricePerKg && (
                        <span>{fixAmount(clientHistory.transaction.pricePerKg)} AZN</span>
                      )}
                    </TableCell>
                    <TableCell>
                      {clientHistory.transaction.amount && (
                        <span>{fixAmount(clientHistory.transaction.amount)} AZN</span>
                      )}
                    </TableCell>
                    <TableCell>{format(clientHistory.createdDate, "dd MMMM yyyy HH:mm")}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>

          {isError(clientHistoryListBranch) && (
            <Center>
              <Box py={3}>
                <ErrorPanel branch={clientHistoryListBranch} />
              </Box>
            </Center>
          )}

          {isSuccess(clientHistoryListBranch) && clientHistoryListBranch.data?.length === 0 && (
            <Center>
              <Box py={3}>
                <Typography>Məlumat yoxdur</Typography>
              </Box>
            </Center>
          )}
        </Paper>
      </Loading>
    </Box>
  );
};
